var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeedsdose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1887_16566",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9777 21.0002C12.2911 21.0048 13.5925 20.7498 14.8071 20.2498C16.0217 19.7499 17.1255 19.0148 18.0552 18.087C18.9872 17.1615 19.7271 16.0609 20.2324 14.8486C20.7378 13.6362 20.9986 12.336 20.9999 11.0225C21.0045 9.70907 20.7494 8.40767 20.2495 7.19308C19.7495 5.9785 19.0145 4.87467 18.0867 3.94502C17.1611 3.01303 16.0606 2.27311 14.8483 1.76776C13.6359 1.26241 12.3357 1.00159 11.0222 1.00029C9.70875 0.995745 8.40735 1.25078 7.19277 1.75073C5.97818 2.25068 4.87435 2.98569 3.9447 3.91355C3.01272 4.83906 2.2728 5.93961 1.76745 7.15195C1.26209 8.3643 1.00127 9.66456 0.999972 10.978C0.995429 12.2915 1.25046 13.5929 1.75041 14.8074C2.25036 16.022 2.98538 17.1259 3.91323 18.0555C4.83874 18.9875 5.93929 19.7274 7.15164 20.2328C8.36398 20.7381 9.66424 20.9989 10.9777 21.0002Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9854 17.5003C11.3169 17.5011 11.6352 17.3701 11.8701 17.1362C12.105 16.9023 12.2374 16.5846 12.2382 16.2531C12.2389 15.9216 12.1079 15.6034 11.874 15.3684C11.6401 15.1335 11.3225 15.0011 10.991 15.0003C10.6594 14.9996 10.3412 15.1306 10.1063 15.3645C9.87133 15.5984 9.73892 15.916 9.73819 16.2476C9.73745 16.5791 9.86844 16.8973 10.1023 17.1323C10.3362 17.3672 10.6539 17.4996 10.9854 17.5003Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0132 5.00049L10.9954 13.0005",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1887_16566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.973389 -1.02637L23.0266 -0.972961L22.9731 23.027L-1.0268 22.9736L-0.973389 -1.02637Z",
    fill: "#CE0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedsdose);
export default __webpack_public_path__ + "static/media/needsdose.d51c43cfc8bef638ad810d321f587e6c.svg";
export { ForwardRef as ReactComponent };